/* This file is autogenerated, see readme.md for instructions */
import UnlockSvgIcon from '@bloomreach/banana-theme/icons/unlock.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const UnlockIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <UnlockSvgIcon />
    </Icon>
  );
});

UnlockIcon.displayName = 'UnlockIcon';

export default UnlockIcon;
